import isJest from 'shared/utils/isJest'

export default (): boolean => !isJest && process.env.APP_ENV !== 'production'
